import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Download } from "lucide-react";
import { download } from "../lib/api";
import { useApi, PageHeader, Loading, Empty, StatusBadge, Select, TableWrap, KpiCard } from "../components/common";
import { InvoiceForm } from "../components/FinanceForms";
import { Button } from "../components/ui/button";
import { fdate, inr } from "../lib/format";

export default function Invoices() {
  const [flt, setFlt] = useState({ q: "", payment_status: "", start: "", end: "" });
  const [open, setOpen] = useState(false);
  const qs = new URLSearchParams(Object.fromEntries(Object.entries(flt).filter(([, v]) => v))).toString();
  const { data, loading, reload } = useApi(`/invoices?${qs}`);
  const s = (k) => (v) => setFlt({ ...flt, [k]: v?.target ? v.target.value : v });
  return (
    <div>
      <PageHeader title="Invoices" subtitle="Balances are derived live from recorded payments" actions={<>
        <Button variant="outline" onClick={() => download("/export/invoices", "invoices.csv")} data-testid="invoice-export-button"><Download className="h-4 w-4 mr-1" />Export</Button>
        <Button className="vmw-gradient" onClick={() => setOpen(true)} data-testid="invoice-add-button"><Plus className="h-4 w-4 mr-1" />New Invoice</Button></>} />
      {data && (
        <div className="grid grid-cols-3 gap-3 mb-4">
          <KpiCard testid="invoices-total" label="Invoiced (shown)" value={inr(data.totals.total)} tone="revenue" />
          <KpiCard testid="invoices-paid" label="Collected" value={inr(data.totals.paid)} tone="cash" />
          <KpiCard testid="invoices-balance" label="Outstanding" value={inr(data.totals.balance)} tone="pending" />
        </div>)}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2 mb-4">
        <input data-testid="invoice-filter-search" className="vmw-input col-span-2" placeholder="Search number, client, project…" value={flt.q} onChange={s("q")} />
        <Select testid="invoice-filter-status" placeholder="All payment statuses" options={["Unpaid", "Partially Paid", "Paid", "Overdue", "Cancelled"]} value={flt.payment_status} onChange={s("payment_status")} />
        <input type="date" className="vmw-input" value={flt.start} onChange={s("start")} data-testid="invoice-filter-start" />
        <input type="date" className="vmw-input" value={flt.end} onChange={s("end")} data-testid="invoice-filter-end" />
      </div>
      <TableWrap>
        {loading && !data ? <Loading /> : !data?.items.length ? <Empty text="No invoices" /> : (
          <table className="vmw-table" data-testid="invoices-table">
            <thead><tr><th>Invoice</th><th>Date</th><th>Client</th><th>Project</th><th className="text-right">Total</th><th className="text-right">Paid</th><th className="text-right">Balance</th><th>Due</th><th>Status</th></tr></thead>
            <tbody>{data.items.map((i) => (
              <tr key={i.id} data-testid={`invoice-row-${i.id}`}>
                <td><Link to={`/invoices/${i.id}`} className="font-mono text-xs font-semibold text-primary">{i.number}</Link></td><td>{fdate(i.date)}</td>
                <td>{i.client_name}<div className="text-xs text-muted-foreground">{i.studio_name}</div></td><td className="text-xs">{i.project_name}</td>
                <td className="text-right font-num">{inr(i.total)}</td><td className="text-right font-num text-emerald-700">{inr(i.amount_paid)}</td>
                <td className="text-right font-num font-semibold">{inr(i.balance)}</td><td>{fdate(i.due_date)}</td><td><StatusBadge value={i.payment_status} /></td>
              </tr>))}</tbody>
          </table>)}
      </TableWrap>
      <InvoiceForm open={open} onClose={() => setOpen(false)} onSaved={reload} />
    </div>
  );
}
